import React from 'react';
import { makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IReduxState } from '../../types';
import { useSelector } from 'react-redux';
import { chartColors } from '../../constants';
import { FormatHelper } from '../../helpers';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
    },
    normalFont: {
      fontSize: 'unset',
    },
    smallFont: {
      fontSize: 12,
    },
  })
);

interface IProps {
  isPdfReport?: boolean;
  isHybrid?: boolean;
}

// Total hours in telemetry time range
export default function TotalHours(props: IProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { isHybrid, isPdfReport } = props;

  const formatHelper = new FormatHelper(t);

  const {
    totalHoursOfCrusherOperation,
    totalHoursOfEngineOperation,
    /*
    totalHoursOfInternalPowerSupply,
    totalHoursOfExternalPowerSupply,
    */
  } = useSelector((state: IReduxState) => state.machineDetails);

  const isThirdParty = useSelector(
    (state: IReduxState) =>
      state.machineDetails.machine.machineType.isThirdParty
  );

  return (
    <div>
      <Typography
        className={classes.title}
        align="center"
        variant="h5"
        style={{
          marginBottom: isHybrid ? 0 : 'inherit',
          marginTop: isHybrid ? '1rem' : '2rem',
        }}
      >
        {t('graph.totalHours')}
      </Typography>

      {false && !isThirdParty && (
        // <Typography
        //   align="left"
        //   className={
        //     isHybrid && isPdfReport ? classes.smallFont : classes.normalFont
        //   }
        // >
        //   {/* {`${t('graph.crusherOperationTotal')}: `}
        //   <span style={{ color: chartColors.rmYellow }}>
        //     {formatHelper.formatSuffixedNumber(totalHoursOfCrusherOperation, t('graph.h'))}
        //   </span> */}
        // </Typography>
        <div />
      )}

      <Typography
        align="left"
        className={
          isHybrid && isPdfReport ? classes.smallFont : classes.normalFont
        }
      >
        {`${t('graph.engineOperationTotal')}: `}
        <span style={{ color: chartColors.rmYellow }}>
          {formatHelper.formatSuffixedNumber(totalHoursOfEngineOperation, t('graph.h'))}
        </span>
      </Typography>

      {/* isHybrid && (
        <div>
          <Typography
            align="left"
            className={isPdfReport ? classes.smallFont : classes.normalFont}
          >
            {`${t('graph.externalPowerSupply')}: `}
            <span style={{ color: chartColors.electricBlue }}>
              {formatHelper.formatSuffixedNumber(totalHoursOfExternalPowerSupply, t('graph.h'))}
            </span>
          </Typography>
          
          <Typography
            align="left"
            className={isPdfReport ? classes.smallFont : classes.normalFont}
          >
            {`${t('graph.internalPowerSupply')}: `}
            <span style={{ color: chartColors.electricBlue }}>
              {formatHelper.formatSuffixedNumber(totalHoursOfInternalPowerSupply, t('graph.h'))}
            </span>
          </Typography>
        </div>
      ) */}
    </div>
  );
}
